<form name="frmProjectMemberAssignment" style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12"
        style="padding-left:0%;padding-right:0%;border-color:black;height:70vw;background-color: #f4f8f6;">
        <div class="panel panel-heading"
            style="padding-left: 15px;padding-top: 0px;padding-bottom: 0px;background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white; ">
            Project Member Assignment</div>
        <div class="panel-body">
            <div class="activity-box" *ngIf="dataLoader">
                <div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load" /></div>
            </div>
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div class="col-sm-3 formdivcaptions" style="width:auto;margin-top:30px;">
                        <label style="color:black;font-weight:bold;margin-right:30px;">Device Type</label>
                        <label *ngFor="let DeviceType of DeviceTypeList">
                            <input type="radio" name="radioDeviceType" value="{{DeviceType.name}}"
                                (change)="DeviceTypeEvent($event)" /><label>&nbsp;{{DeviceType.name}}&nbsp; </label>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div id="divProjectDetailsCommon" style="display:none;">
                        <div class="col-sm-3 formDivCaptions">
                            <label for="dlstProjectName">Project Name</label>
                            <select class="form-control col-sm-4" id="dlstProjectName" name="dlstProjectName">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let P of ProjectList">{{P.ProjectName}}</option>
                            </select>
                        </div>
                        <div class="col-sm-3 formDivCaptions">
                            <label for="dlstCountry">Country</label>
                            <select class="form-control col-sm-4" id="dlstCountry" name="dlstCountry">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let C of Countries">{{C.Country}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-6 formdivcaptions" style="margin-top:2%;">
                        <div align="left" id="divProjectDetailsSubmit" style="display:none;">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span>Search</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" *ngIf="Country=='India' && Device == 'Cisco'" id="btnExcelExport" class="btn btn-default btn-group-sm Button1" (click)="ExportToBulkExcel()"><span class="glyphicon glyphicon-export" aria-hidden="true"></span> Export to Excel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr style="margin-top: -10px;display:none;" id="uploadhr">
        <form [formGroup]="addModifyHostNamesForm">
        <div class="form-group row" id="divProjectDetailsCommonupload" style="display:none;">
            <div class="col-sm-3" style="margin-left:4%;">
                <label for="UploadFile">For Project Members Bulk Upload</label>
            </div>
            <div class="col-sm-8 ">
                <div class="row ">
                    <div class=" col-sm-5 ">
                        <input type="file" formControlName="inputFile" style="height:33px;position:relative;" id = "fileControl"
                            placeholder="Upload Input" (change)="setFile($event)"/>
                    </div>
                    <div class="col-sm-2">
                        <a download="BulkProjectNames.xlsx" target="_blank" title="Download Template"
                            class="btn btn-info btn-mg glyphicon glyphicon-download-alt"
                            href="assets/documents/BulkProjectNames.xlsx">
                        </a>
                    </div>
                </div>
            </div>
            <!-- <div class="col-sm-12 ">
                <div class="row ">
                    <div style="color:red">
                        <span style="margin-left:4%;">Note: Project names should be unique</span>
                    </div>
                </div>
            </div> -->
            <br>
            <div class="row">
                <div class="col-md-2 col-md-offset-5" style="margin-top: 20px;">
                    <button type="submit" class="btn btn-default btn-group-sm Button1" (click)="addFileDetails()">
                        <span class="fa fa-check-circle" aria-hidden="true">
                        </span> Upload File
                    </button>
                </div>
            </div>
        </div>
    </form>
        <br>
        <div class="row" id="divProjectDetails" style="display:none;">
            <div style="margin-left: 20px; margin-right: 20px;">

                <table id="ProjectDetailsSkype" class="table table-bordered" border="1"
                    style="margin-left:2.7%;width:95%;font-size:13px;display:none;">
                    <tr
                        style="color: white;background: #8064A2; height:25px; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                        <th style="display:none">S.No</th>
                        <th style="text-align: center;"></th>
                        <th style="text-align: center;">Country</th>
                        <th style="text-align: center;">Project Name</th>
                        <th style="text-align: center; ">Project Lead</th>
                        <th style="text-align: center;width:20%; ">Type</th>
                        <th style="text-align: center;">Project Members</th>
                    </tr>
                    <!-- <tbody *ngFor="projectMemberAssignment in successfulData.projectMemberAssignments | paginate:rowsPerPage" ng-include="getTemplate2(projectMemberAssignment)"></tbody> -->
                    <tbody *ngFor="let projectMemberAssignment of successfulData.projectMemberAssignments">
                        <tr *ngIf="projectMemberAssignment.Id != this.successfulData.selected.Id">
                            <td style="display:none">{{projectMemberAssignment.Id}}</td>
                            <td>
                                <img src="assets/img/Edit-icon.png" title="Edit"
                                    (click)="EditProject(projectMemberAssignment)" />
                                <img src="assets/img/Delete.png" title="Delete"
                                    (click)="DeleteProject(projectMemberAssignment)" />
                            </td>
                            <td>{{projectMemberAssignment.Country}}</td>
                            <td>{{projectMemberAssignment.ProjectName}}</td>
                            <td>{{projectMemberAssignment.ProjectLead}}</td>
                            <td>{{projectMemberAssignment.Type}}</td>
                            <td>{{projectMemberAssignment.GroupMembers}}</td>
                        </tr>
                        <tr *ngIf="projectMemberAssignment.Id === this.successfulData.selected.Id">
                            <td>
                                <img src="assets/img/Add.png" (click)="ProjectUpdate(projectMemberAssignment)"
                                    title="Update" />
                                <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                            </td>
                            <td style="display:none;">{{successfulData.selected.Id}}</td>
                            <td>
                                <select class="form-control col-sm-4" id="grdCountries" name="grdCountries"
                                    [(ngModel)]="successfulData.selected.Country">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries" [ngValue]="C.Country">{{C.Country}}</option>
                                </select>
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdProjectName" name="grdProjectName" maxlength="50"
                                    [(ngModel)]="successfulData.selected.ProjectName" />
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdProjectLead" name="grdProjectLead"
                                    [(ngModel)]="successfulData.selected.ProjectLead" />
                            </td>
                            <td>
                                <select class="form-control col-sm-4" id="grdType" name="grdType"
                                    [(ngModel)]="successfulData.selected.Type">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let SkypeType of SkypeTypeList" value="{{SkypeType.Value}}">
                                        {{SkypeType.Value}}</option>
                                </select>
                            </td>
                            <td>
                                <textarea class="form-control" id="grdProjectMembers" name="grdProjectMembers"
                                    [(ngModel)]="successfulData.selected.GroupMembers"
                                    (change)="ProjectMember('Edit')"></textarea>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <button id="btnAddProjectMemberAssignment1" type="button"
                                    class="btn btn-default btn-group-sm Button1" (click)="ProjectAdd()">
                                    <span class="fa fa-check-circle" aria-hidden="true">
                                    </span> Add
                                </button>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdfCountries" name="grdfCountries"
                                    [(ngModel)]="Project.Country" aria-labelledby="grdfCountries">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfProjectName" name="grdfProjectName" maxlength="50"
                                    [(ngModel)]="Project.ProjectName" placeholder="ProjectName" />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfProjectLead" name="grdfProjectLead"
                                    [(ngModel)]="Project.ProjectLead" placeholder="ProjectLead"/>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-3%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdfType" name="grdfType"
                                    [(ngModel)]="Project.Type" aria-labelledby="grdfType">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor=" let SkypeType of SkypeTypeList" value="{{SkypeType.Value}}">
                                        {{SkypeType.Value}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-3%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <textarea class="form-control" id="grdfProjectMembers" name="grdfProjectMembers"
                                    [(ngModel)]="Project.GroupMembers" (change)="ProjectMember('Display')" placeholder="ProjectMembers"></textarea>
                                <div><span style="margin-left:2%;color:red;">Note: Please enter 5 or less
                                        Enterprise/Group Id's separated by comma.</span></div>

                            </td>
                        </tr>
                        <!-- <tr>
                            <td colspan="11" style="text-align: center;">
                                <paginator></paginator>
                            </td>
                        </tr> -->
                        <tr>
                            <td colspan="11" style="text-align: center;">
                                <!-- pager -->
                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                        </a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(pager.currentPage - 1)"
                                                class="icon-step-backward"></i></a>
                                    </li>
                                    <li *ngFor="let page of pager.pages"
                                        [ngClass]="{active:pager.currentPage === page}">
                                        <a (click)="setPage(page)">{{page}}</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                        <a (click)="setPage(pager.startPage + 5)">...</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5">
                                        <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                    </li>

                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.currentPage + 1)"
                                                class="icon-step-forward"></i></a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <table id="ProjectDetailsCisco" class="table table-bordered" border="1"
                    style="margin-left:2.7%;font-size:13px;display:none; width:95%;">
                    <tr
                        style="color: white;background: #8064A2; height:25px; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                        <th style="display:none">S.No</th>
                        <th style="text-align: center;"></th>
                        <th style="text-align: center;">Country</th>
                        <th style="text-align: center;">Project Name</th>
                        <th style="text-align: center;">Project Lead</th>
                        <th style="text-align: center;">Type</th>
                        <th style="text-align: center;">User EnterpriseID</th>
                        <th style="text-align: center;">WBSE</th>
                        <th style="text-align: center;">AuthCode</th>
                        <th style="text-align: center;">Phone Number</th>
                    </tr>
                    <!-- <tbody *ngFor="projectMemberAssignment in successfulData.projectMemberAssignments | paginate:rowsPerPage" ng-include="getTemplate2(projectMemberAssignment)"></tbody> -->
                    <tbody *ngFor="let projectMemberAssignment of successfulData.projectMemberAssignments">
                        <tr *ngIf="projectMemberAssignment.Id != this.successfulData.selected.Id">
                            <td style="display:none">{{projectMemberAssignment.Id}}</td>
                            <td>
                                <img src="assets/img/Edit-icon.png" title="Edit"
                                    (click)="EditProject(projectMemberAssignment)" />
                                <img src="assets/img/Delete.png" title="Delete"
                                    (click)="DeleteProject(projectMemberAssignment)" />
                            </td>
                            <td>{{projectMemberAssignment.Country}}</td>
                            <td>{{projectMemberAssignment.ProjectName}}</td>
                            <td>{{projectMemberAssignment.ProjectLead}}</td>
                            <td>{{projectMemberAssignment.Type}}</td>
                            <td>{{projectMemberAssignment.UserId}}</td>
                            <td>{{projectMemberAssignment.WBSEelement}}</td>
                            <td>{{projectMemberAssignment.AuthCode}}</td>
                            <td>{{projectMemberAssignment.PhoneNumber}}</td>
                        </tr>
                        <tr *ngIf="projectMemberAssignment.Id === this.successfulData.selected.Id">
                            <td>
                                <img src="assets/img/Add.png" (click)="ProjectUpdate(projectMemberAssignment)"
                                    title="Update" />
                                <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                            </td>
                            <td style="display:none;">{{successfulData.selected.Id}}</td>
                            <td>
                                <select class="form-control col-sm-4" id="grdECCountries" name="grdECCountries"
                                    [(ngModel)]="successfulData.selected.Country">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries" [ngValue]="C.Country">{{C.Country}}</option>
                                </select>
                            </td>

                            <td>
                                <input type="text" class="form-control" id="grdECProjectName" name="grdECProjectName" maxlength="50"
                                    [(ngModel)]="successfulData.selected.ProjectName" />
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdECProjectLead" name="grdECProjectLead"
                                    [(ngModel)]="successfulData.selected.ProjectLead" />
                            </td>
                            <td>
                                <select class="form-control col-sm-4" id="grdECType" name="grdECType"
                                    [(ngModel)]="successfulData.selected.Type">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let CiscoType of CiscoTypeList" value="{{CiscoType.Value}}">
                                        {{CiscoType.Value}}</option>
                                </select>
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdUserID" name="grdUserID"
                                    [(ngModel)]="successfulData.selected.UserId" />
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdWBSE" name="grdWBSE"
                                    [(ngModel)]="successfulData.selected.WBSEelement" maxlength="8" />
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdAuthCode" name="grdAuthCode"
                                    [(ngModel)]="successfulData.selected.AuthCode" maxlength="7" />
                            </td>
                            <td>
                                <input type="text" class="form-control" id="grdPhoneNumber" name="grdPhoneNumber"
                                    [(ngModel)]="successfulData.selected.PhoneNumber"
                                    (keypress)="validateNumber($event)" />
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <button id="btnAddProjectMemberAssignment" type="button"
                                    class="btn btn-default btn-group-sm Button1" (click)="ProjectAdd()">
                                    <span class="fa fa-check-circle" aria-hidden="true">
                                    </span> Add
                                </button>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdCCountries" name="grdCCountries" aria-labelledby="grdCCountries"
                                    [(ngModel)]="Project.Country">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </td>

                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdCProjectName" name="grdCProjectName" maxlength="50"
                                    [(ngModel)]="Project.ProjectName" placeholder="ProjectName" />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdCProjectLead" name="grdCProjectLead"
                                    [(ngModel)]="Project.ProjectLead" placeholder="ProjectLead"/>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdCType" name="grdCType"
                                    [(ngModel)]="Project.Type" aria-labelledby="grdCType">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let CiscoType of CiscoTypeList" value="{{CiscoType.Value}}">
                                        {{CiscoType.Value}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfUserID" name="grdfUserID"
                                    [(ngModel)]="Project.UserId" placeholder="User ID" />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfWBSE" name="grdfWBSE"
                                    [(ngModel)]="Project.WBSEelement" maxlength="8" placeholder="WBSE"/>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfAuthCode" name="grdfAuthCode"
                                    [(ngModel)]="Project.AuthCode" maxlength="7" placeholder="AuthCode" />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;"
                                    class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfPhoneNumber" name="grdfPhoneNumber"
                                    [(ngModel)]="Project.PhoneNumber" (keypress)="validateNumber($event)" placeholder="PhoneNumber"/>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td colspan="11" style="text-align: center;">
                                <paginator></paginator>
                            </td>
                        </tr> -->
                        <tr>
                            <td colspan="11" style="text-align: center;">
                                <!-- pager -->
                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                        </a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(pager.currentPage - 1)"
                                                class="icon-step-backward"></i></a>
                                    </li>
                                    <li *ngFor="let page of pager.pages"
                                        [ngClass]="{active:pager.currentPage === page}">
                                        <a (click)="setPage(page)">{{page}}</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                        <a (click)="setPage(pager.startPage + 5)">...</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5">
                                        <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                    </li>

                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.currentPage + 1)"
                                                class="icon-step-forward"></i></a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div id="AlertForAccess" style="display:none;">
            <div class="row" style="padding-top:-20%">
                <div class="col-sm-12" style="margin-left:5%;">
                    <h4 style="color:red;">
                        Access Not Available.Please refer User Guidelines section for any access or tool issue.
                    </h4>
                </div>

            </div>

        </div>
    </div>
</form>